/*!

=========================================================
* Argon Design System React - v1.1.2
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from 'react';

// reactstrap components
import {
  Card,
  Container,
  Row,
  Col,
  Progress, Button
} from "reactstrap";

// core components


import ScripturesDropdown from "./ScripturesDropdown";
import '../../the-worship-bible-2.css';
import StatsOverview from "../stats/StatsOverview";
import withNavigationHook from "../../hooks/withNavigationHook";
import {RiEditFill} from "react-icons/ri";
import SeoNoIndex from "../../components/helpers/SeoNoIndex";
import {SeoHelper} from "../../components/helpers/SeoHelper";

// index page sections

class ChooseScripturePassages extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      activeButtonActive: false,
      continueButtonEnabled: false
    };

    this.enableActiveButtonHandler = this.enableActiveButtonHandler.bind(this);
  }

  componentDidMount() {
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'build_service', {
        source: 'scripture'
      });
    }
  }

  clearPassageListHandler = () => {
    sessionStorage.removeItem("selected-passages");
    this.setState({chosenPassageButtons: []});
    this.setState({activeButtonActive: false});
    sessionStorage.setItem("scriptureContinueEnabled", false);

    this.forceUpdate();
  }

  enableActiveButtonHandler = (enable) => {
    this.setState({activeButtonActive: enable});
    this.continueButtonAvailable();

    this.forceUpdate();
  }

  continueButtonAvailable = () => {
    sessionStorage.setItem("scriptureContinueEnabled", sessionStorage.getItem("selected-passages") && JSON.parse(sessionStorage.getItem("selected-passages")).length > 0);
  }

  render() {
    const continueButtonEnabled = sessionStorage.getItem("selected-passages") && JSON.parse(sessionStorage.getItem("selected-passages")).length > 0;

    return (
      <>
        <SeoHelper
            uri="/scripture/choose-passages"
            title = "Choose one or more Scripture Passages | The Worship Bible"
            description="Find worship songs that align with your chosen Scripture passage. The Worship Bible helps you create meaningful song-flows rooted in biblical themes and teachings."
        />
        
        {/*<main className="profile-page" ref="main">*/}
        <div className="position-relative">
          {/* shape Hero */}
          <section className="section section-lg section-shaped pb-10">
            <div className="shape shape-style-1 shape-default">
              <span />
              <span />
              <span />
              <span />
              <span />
              <span />
              <span />
              <span />
              <span />
            </div>
            <Container className="py-lg-md d-flex">
              <div className="col px-0">
                <Row>
                  <Col lg="8">
                    <h1 className="display-3 text-white">
                      Building your song-flows{" "}
                      <span>choose scripture passages</span>
                    </h1>
                    <p className="lead text-white">
                      &nbsp;<br/>&nbsp;
                    </p>
                    {/*<div className="btn-wrapper">*/}
                    {/*  <Button*/}
                    {/*    className="btn-icon mb-3 mb-sm-0"*/}
                    {/*    color="primary"*/}
                    {/*    href="/do-you-use-a-lectionary-or-song-book"*/}
                    {/*  >*/}
                    {/*    <span className="btn-inner--icon mr-1">*/}
                    {/*      <i className="fa fa-music" />*/}
                    {/*    </span>*/}
                    {/*    <span className="btn-inner--text">Generate a Worship Playlist</span>*/}
                    {/*  </Button>*/}
                    {/*</div>*/}
                  </Col>
                </Row>
              </div>
            </Container>
            {/* SVG separator */}
            <div className="separator separator-bottom separator-skew">
              <svg
                  xmlns="http://www.w3.org/2000/svg"
                  preserveAspectRatio="none"
                  version="1.1"
                  viewBox="0 0 2560 100"
                  x="0"
                  y="0"
              >
                <polygon
                    className="fill-white"
                    points="2560 0 2560 100 0 100"
                />
              </svg>
            </div>
          </section>
          {/* 1st Hero Variation */}
        </div>
        <section className="section section-lg pt-lg-9">
          <Container>
            <Card className="card-profile shadow mt--300">
              <div className="px-4">
                <Row className="mt-3">
                  <Col md="3" xs="12">
                  </Col>
                  <Col md="6" xs="12">
                  </Col>
                  <Col md="3" xs="12">
                    <div className="text-center">
                    {(
                          (sessionStorage.getItem("curated-songs") && sessionStorage.getItem("curated-songs") != 'null' && JSON.parse(sessionStorage.getItem("curated-songs")).length > 0 && !sessionStorage.getItem("playlist")) ||
                          (sessionStorage.getItem("playlist") && sessionStorage.getItem("workingOnDraft") === "true")
                      ) && <>
                      <Button
                          className="btn-icon mb-3 mb-sm-0 mx-auto float-left"
                          color="primary"
                          href="/scripture/curated-songs"
                      >
                                <span className="btn-inner--icon mr-1">
                                  <RiEditFill title="Edit" size="16"/>
                                </span>
                          <span className="btn-inner--text">Go to song-flow</span>
                      </Button>
                    </>
                    }
                    </div>
                  </Col>
                </Row>
                <StatsOverview/>
                <div className="mb-2"></div>
                <ScripturesDropdown key={new Date()} enableActiveButtonHandler={this.enableActiveButtonHandler}/>
                <div style={{
                  position: "fixed",
                  bottom: "0",
                  left: "0",
                  width: "100%",
                  backgroundColor: "white",
                  padding: "40px",
                  boxShadow: "0 -2px 5px rgba(0, 0, 0, 0.2)",
                  zIndex: "1000"
                }}>
                  <div className="col-md-12 col-xs-12"
                       style={{position: "relative", bottom: "0px", right: "0px", zIndex: "1000"}}>
                    <Row>
                      <Col lg="3">
                        <div className="btn-wrapper">
                        </div>
                      </Col>
                      <Col lg="1"/>
                      <Col lg="5">
                        <div className="btn-wrapper">
                          <Button
                              type="submit"
                              id="clearAllButton"
                              className="btn-icon"
                              color="secondary"
                              onClick={() => this.clearPassageListHandler()}
                              style={{width: "100%"}}
                              disabled={!sessionStorage.getItem("selected-passages") ? true : sessionStorage.getItem("selected-passages") > 0}
                          >
                            <span className="btn-inner--text"><i className="fa fa-trash-o" aria-hidden="true"></i>Remove All Selected Passages</span>
                          </Button>
                        </div>
                      </Col>
                      <Col lg="3">
                        <div className="btn-wrapper">
                          <Button
                              type="submit"
                              id="continueButton"
                              className="btn-icon"
                              color="primary"
                              href="/scripture/songs"
                              disabled={!continueButtonEnabled}
                              style={{width: "100%"}}
                          >
                            <span className="btn-inner--text">Continue</span>
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
                {/*</form>*/}
                {/*<div className="mt-5 py-5 border-top text-center">*/}
                {/*  <div className="progress-wrapper">*/}
                {/*    <div className="progress-info">*/}
                {/*      <div className="progress-label">*/}
                {/*        <span>WORSHIP SONG-FLOWS CREATION TASKS COMPLETED</span>*/}
                {/*      </div>*/}
                {/*      <div className="progress-percentage">*/}
                {/*        <span>2/4</span>*/}
                {/*      </div>*/}
                {/*    </div>*/}
                {/*    <Progress max="100" value="50"/>*/}
                {/*  </div>*/}
                {/*</div>*/}
              </div>
            </Card>
          </Container>
        </section>
        {/*</main>*/}

      </>
    );
  }
}

export default withNavigationHook(ChooseScripturePassages);
